export default __webpack_public_path__ + "static/media/icons-system-close-dialog.b34dedc0.svg";